import { Participant } from "@domain";
import {
  IBlocSyncInteractor,
  SyncInteractor
} from "@kernel/frontend-react-app";

export interface ChangeParticipantDataInteractorProps<P extends Participant> {
  participant: P;
  displayName: string;
}

export class ChangeParticipantDataInteractor<P extends Participant>
  extends SyncInteractor<ChangeParticipantDataInteractorProps<P>, P>
  implements IBlocSyncInteractor<ChangeParticipantDataInteractorProps<P>, P>
{
  public execute({
    participant,
    displayName
  }: ChangeParticipantDataInteractorProps<P>): P {
    participant.data.displayName = displayName;
    return participant;
  }

  public static create<
    P extends Participant
  >(): ChangeParticipantDataInteractor<P> {
    return new ChangeParticipantDataInteractor();
  }
}
